module.exports = __webpack_public_path__ + "static/img/10002 (1).ab769cf.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10002 (1).webp
// module id = V86y
// module chunks = 14